import { getProjects } from '@/api/project';
import moment, { Moment } from 'moment';
import { isOverTime } from './other';

type IProjectInfo = IProject.IResponse.IProjectInfo;

export let companyAllProject: IProjectInfo[] = [];

let loadedTime: Moment | null = null;
export const getCompanyAllProject = (force: boolean = false): Promise<string> => {
  return new Promise((resolve, reject) => {
    const minute = force ? -1 : 3;
    if (!isOverTime(loadedTime, minute)) {
      resolve('');
      return;
    }
    getProjects({active: true}).then((res) => {
      companyAllProject = res.data;
      loadedTime = moment();
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};

export const findProjectById = (
  projectId: string,
): IProject.IResponse.IProjectInfo | undefined => {
  return companyAllProject.find((project) => project.id === projectId);
};

export const getActiveProjects = (search: IProject.IRequest.IGetProject): Promise<IProjectInfo[]> => {
  const params = Object.assign(search, {active: true});
  return new Promise((resolve, reject) => {
    getProjects(params).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
